import c_8 from "../../assets/audio-screen/unit8/c_8.mp3"
import c_8_1 from "../../assets/audio-screen/unit8/c_8_1.mp3"


export const audio8 = [
   {
    'text':'Nga: Chào các bạn, mời các bạn vào nhà.\nDavid: Cảm ơn Nga. Hôm nay Nga có khỏe không?\nNga: Tất nhiên rồi, thế còn các bạn?\nDavid: Chúng tôi đều khỏe.\nNga: Hôm nay mình có bữa tiệc nhỏ mời các bạn, mình đã chuẩn bị một số đồ ăn và đồ uống. Các bạn muốn ăn gì nào?\nLouis: Tớ muốn biết  món ăn ẩm thực của người Việt Nam.\nDavid: Tớ muốn hiểu cách nấu ăn của người Việt Nam, chúng ta sẽ cùng nhau nãu ăn nhé?\nNga: Thật là tuyệt. Vậy chúng ta sẽ cùng nhau nấu món gà rang.\nLouis: Bếp ở đâu vậy Nga? Món này cần những nguyên liệu gì ạ?\nNga: Ở đằng kia. Chúng ta cần thịt gà, dầu ăn, cây xả, lá chanh, đường, nước mắm và ớt.\nLouis: Cậu dậy tớ cách nấu như thế nào nhé?\nNga: Tất nhiên rồi.\nDavid: Cảm ơn Nga. Mời vào.\n',
    'audio': c_8,
  },

];

export const audio8_1 = [
    {
     'text':'Misaki: Yuki sáng nay con muốn ăn gì?\nYuki: Dạ. Con thích ăn bánh mì và sữa ạ.\nMisaki: Được rồi. Mẹ gọi món cho con nhé.\nYuki: Thế còn mẹ ăn gì ạ?\nMisaki: Mẹ sẽ ăn phở gà và ướng cà phê, của con đây.\nYuki: Con cảm ơn mẹ ạ.\nMisaki: Con cảm thấy bánh mì và sữa ở đây thế nào?\nYuki: Rất ngon mẹ ạ.\n',
     'audio': c_8_1,
   },
 
 ];